<template>
  <v-container>
    <v-row
      justify="start"
      align="center"
      class="mt-4"
    >
      <div
          style="width: 150px"
          class="mr-10"
      >
        <v-select
            label="Customer"
            :items="compositeCustomersList"
            v-model="currentCompositeCustomer"
            item-text="label"
            item-value="id"
            return-object
            @change="changeCustomer"
        />
      </div>

      <div
          style="width: 200px"
          class="mr-10"
          v-if="availableDashboards.length > 1"
      >
        <v-select
            label="Dashboard"
            :items="availableDashboards"
            v-model="selectedDashboardId"
            item-text="name"
            item-value="id"
            @change="changeDashboard"
        />
      </div>

      <div
          style="width: 200px"
          class="mr-3"
      >
        <v-select
            label="Period type"
            :items="periodSelect"
            v-model="periodSelectedComputed"
            @change="selectPeriod"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title
                  v-text="item.text"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
        <v-dialog
            v-model="isDatepickerDialogOpen"
            persistent
            width="290px"
        >
          <v-date-picker
              v-model="customDateRange"
              range
              :max="formattedDate()"
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="cancelDateRangeDialog"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="saveDataRange"
                :disabled="isEmptyCustomDateRange"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </div>

      <div
          v-if="periodSelected === 'custom'"
          style="width: 300px; font-weight: bold"
          class="mr-10 item-clicker"
          @click="openDateRangeDialog"
      >
        {{ shownDate }}
      </div>
      <div
          v-else
          style="width: 300px"
          class="mr-10"
      >
        {{ shownDate }}
      </div>

      <div
          class="mr-10"
      >
        <v-btn
            :color="!isFiltersChanged ? 'info' : 'warning' "
            class="ma-2"
            @click="getData"
            :outlined="!isFiltersChanged"
        >
          {{ isFiltersChanged ? 'Update' : 'Updated ' }}
        </v-btn>
      </div>
      <div
          v-if="hasAnyAbility(
                $constants.ABILITY.EXPORT,
            )"
          class="mr-10"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="ma-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="exportData"
            >
              <v-icon>
                mdi-export
              </v-icon>
            </v-btn>
          </template>
          {{
            isExportRangeIncompleteUtcDay
              ? 'export is unavailable for the current UTC day'
              : 'export data'
          }}
        </v-tooltip>
      </div>
      <div
          v-if="hasAnyAbility(
                $constants.ABILITY.EXPORT_SEARCH,
            )"
          class="mr-10"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
          <v-btn
              class="ma-2"
              color="warning"
              v-bind="attrs"
              v-on="on"
              @click="exportSearchData"
          >
            <v-icon>
              mdi-auto-download
            </v-icon>
          </v-btn>
          </template>
          export search data
        </v-tooltip>
      </div>
      <div>
        <v-switch
            v-model="isGlobalPercentComputed"
            :label="isGlobalPercentComputed ? 'percent' : 'absolute values'"
        />
        <v-radio-group
            v-if="hasAnyAbility(
                $constants.ABILITY.SELECT_REQUEST_METHOD,
            )"

            v-model="requestType"
            mandatory
        >
          <v-radio
              label="multiple"
              value="multiple"
          />
          <v-radio
              label="single spatie"
              value="single_spatie"
          />
          <v-radio
              label="single swoole"
              value="single_swoole"
          />
          <v-radio
              label="single united"
              value="single_united"
          />
        </v-radio-group>
      </div>
    </v-row>
    <v-row
      v-if="isDashboardLoaded"
    >
      <v-col>
        <v-tabs
            v-model="currentAnalyticsTab"
        >
          <v-tab
              v-for="(tab, key) in dashboardStructure.tabs"
              :key="key"
          >
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <div class="main-body"
         v-if="isDashboardLoaded"
    >
      <LayoutBuilder
        v-if="dashboardStructure.static && dashboardStructure.static.is_shown"
        :layout-item="dashboardStructure.static"
      />

      <v-tabs-items
          v-model="currentAnalyticsTab"
      >
        <v-tab-item
            v-for="(tab, key) in dashboardStructure.tabs"
            :key="key"
        >
          <LayoutBuilder
              :layout-item="tab"
          />
        </v-tab-item>
      </v-tabs-items>

    </div>
    <LinearProgressNum
        :show="loading"
        :progress="loadedMetricsPercent"
    />
    <StandBy
        :show="bulkLoading"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import LinearProgressNum from '../components/LinearProgressNum.vue';
import LayoutBuilder from '../components/dasboard/layouts/LayoutBuilder.vue';
import StandBy from '../components/StandBy.vue';

export default {
  name: 'Analytics',

  components: {
    LayoutBuilder,
    LinearProgressNum,
    StandBy,
  },

  data() {
    return ({
      reportMetrics: [],
      isFiltersChanged: true,

      isDashboardLoaded: false,
      dashboardStructure: {},

      requestType: 'single_swoole',

      requestMetrics: [],

      currentAnalyticsTab: 1,

      loading: false,
      bulkLoading: false,

      periodSelect: [
        { text: 'Today', value: 'today' },
        { divider: true },
        { text: 'Custom range', value: 'custom' },
        { divider: true },
        { text: 'Last day', value: 'hour_24' },
        { text: 'Last 7 days', value: 'day_7' },
        { text: 'Last 30 days', value: 'day_30' },
        { divider: true },
        { text: 'Month to Date', value: 'this-month' },
        { text: 'Last month', value: 'month_1' },
        { text: 'Last 6 months', value: 'month_6' },
        { text: 'Last 12 months', value: 'month_12' },
        { divider: true },
        { text: 'Year to Date', value: 'this-year' },
      ],

      monthFullNames: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ],
      dayOfWeekNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      customDateRange: [],
      isDatepickerDialogOpen: false,
      isDisabledNextButton: true,
      currentDate: null,
      beginDate: null,
      endDate: null,
      wasScrollButtonsDisabled: true,
      previouslyShownDate: null,
      bigQueryTablesList: [],
      logVersionsList: [],

    });
  },

  async created() {
    await this.initPage();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
      resetCompositeCustomersList: 'compositeCustomers/resetCompositeCustomersList',
      clearMetricsData: 'metrics/clearMetricsData',
      addMetricsData: 'metrics/addMetricsData',
      setMetricsData: 'metrics/setMetricsData',
      setMetricData: 'metrics/setMetricData',
      setIsGlobalPercent: 'controls/setIsGlobalPercent',
      setPeriodSelected: 'controls/setPeriodSelected',
      setAirportAppUrl: 'metrics/setAirportAppUrl',
      setIsUseStaticMetricsData: 'metrics/setIsUseStaticMetricsData',
      setIsCompositeCustomerHasAirport: 'metrics/setIsCompositeCustomerHasAirport',
    }),

    async fetchDashboardStructure() {
      const response = await this.axios
        .post(
          'api/admin/dashboard/getCompositeCustomerData',
          {
            composite_customer_id: this.currentCompositeCustomer.id,
            dashboard_id: this.selectedDashboardId,
          },
        );

      this.dashboardStructure = JSON.parse(JSON.stringify(response.data.dashboard));
      this.selectedDashboardId = response.data.selected_dashboard_id;
      await this.setIsCompositeCustomerHasAirport(response.data.options.has_airport);
      await this.setAirportAppUrl(response.data.options.app_url);

      this.isDashboardLoaded = true;
    },

    formattedDate(date = new Date()) {
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    async initPage() {
      await this.setIsUseStaticMetricsData(false);
      await this.resetCompositeCustomersList();

      this.periodSelectedComputed = 'month_6';
      if (this.hasAllAbilities(this.$constants.ABILITY.CUSTOMER)) {
        this.periodSelectedComputed = 'day_30';
        this.isGlobalPercentComputed = true;
      }
      this.currentAnalyticsTab = 0;

      await this.initBoundsTime();

      await this.fetchDashboardStructure();

      if (this.hasAllAbilities(this.$constants.ABILITY.CUSTOMER)) {
        await this.getData();
      }
    },

    async fulfillWithTimeLimit(task, timeLimit = 20000, failureValue = null) {
      let timeout;
      const timeoutPromise = new Promise((resolve) => {
        timeout = setTimeout(() => {
          resolve(failureValue);
        }, timeLimit);
      });

      const response = await Promise.race([task, timeoutPromise]);

      if (timeout) {
        clearTimeout(timeout);
      }

      return response;
    },

    async fulfillWithCounter(task, requestedMetric) {
      const itemIndex = this.reportMetrics
        .findIndex((el) => el.metricKey === requestedMetric.metric.key);

      return new Promise((resolve) => {
        task.then((data) => {
          // eslint-disable-next-line no-param-reassign
          this.reportMetrics[itemIndex].error = 0;
          resolve(data);
        }).catch((error) => {
          // eslint-disable-next-line no-param-reassign
          this.reportMetrics[itemIndex].error = 1;
          // eslint-disable-next-line no-param-reassign
          this.reportMetrics[itemIndex].errorInfo = error;

          resolve({
            data: {
              result: [],
            },
            error: true,
          });
        }).finally(() => {
          // eslint-disable-next-line no-param-reassign
          this.reportMetrics[itemIndex].status = 1;
        });
      });
    },

    changeFilters(flag = true) {
      this.isFiltersChanged = flag;
    },

    collectDashboardMetrics() {
      const requiredMetrics = [];
      if (
        this.dashboardStructure.static.layout.positions
          && this.dashboardStructure.static.is_shown
      ) {
        const positions = Object.values(this.dashboardStructure.static.layout.positions);

        positions.forEach((position) => {
          Object.values(position.metric_items).forEach((metricItem) => {
            if (metricItem.metrics) {
              requiredMetrics.push(...metricItem.metrics);
            }
          });
        });
      }

      Object.values(this.dashboardStructure.tabs).forEach((tab) => {
        if (tab.layout) {
          const positions = Object.values(tab.layout.positions);

          positions.forEach((position) => {
            Object.values(position.metric_items).forEach((metricItem) => {
              if (metricItem.metrics) {
                requiredMetrics.push(...metricItem.metrics);
              }
            });
          });
        }
      });

      return [...new Set(requiredMetrics)];
    },

    prepareRequestMetrics(collectedMetrics) {
      this.reportMetrics = [];

      const requestMetrics = [];

      this.currentDate = new Date();
      this.currentDate.setMinutes(0, 0, 0);

      const curBeginTimestamp = this.beginDate.getTime();

      const curEndTimestamp = this.endDate.getTime();

      // subtracted 1 ms compensation
      const timeDiff = curEndTimestamp - curBeginTimestamp;

      const curPrevBeginTimestamp = curBeginTimestamp - timeDiff - 1;

      // eslint-disable-next-line no-restricted-syntax
      for (const metricAlias of collectedMetrics) {
        // eslint-disable-next-line no-restricted-syntax
        for (const intervalType of this.metricsList[metricAlias].time_interval_types) {
          let beginTimestamp = intervalType === 'cur'
            ? curBeginTimestamp : curPrevBeginTimestamp;
          let endTimestamp = intervalType === 'cur'
            ? curEndTimestamp : curBeginTimestamp - 1;

          if (metricAlias === 'unique_users_date_particular') {
            beginTimestamp = (new Date(
              Date.UTC(
                this.currentDate.getUTCFullYear(),
                this.currentDate.getUTCMonth() - 2,
                1, 0, 0, 0, 0,
              ),
            )).getTime();
            endTimestamp = this.currentDate.getTime();
          }

          const metricKey = `${metricAlias}_${intervalType}`;

          const requestMetric = {
            metric: { type: this.metricsList[metricAlias].requestType, key: metricKey },
            date_begin: new Date(beginTimestamp).toISOString().slice(0, 10),
            date_end: new Date(endTimestamp).toISOString().slice(0, 10),
            composite_customer: this.currentCompositeCustomer.id,
          };

          requestMetrics.push(requestMetric);

          const metricItem = {
            name: this.metricsList[metricAlias].taskName,
            status: 0,
            error: 1,
            metricKey,
          };

          this.reportMetrics.push(metricItem);
        }
      }

      return requestMetrics;
    },

    async getData() {
      await this.clearMetricsData();
      const dashboardMetrics = this.collectDashboardMetrics();

      const metricsResponseData = this.requestType === 'multiple'
        ? await this.getAnalytics(dashboardMetrics)
        : await this.getAnalyticsBulk(dashboardMetrics);

      await this.setMetricsData(metricsResponseData);
    },

    async getAnalytics(collectedMetrics, isNeedUpdateFilters = true) {
      const metricsData = [];
      this.loading = true;

      // eslint-disable-next-line max-len
      const requestMetrics = this.prepareRequestMetrics(collectedMetrics);

      try {
        const metricsResults = await this.analyticsResolve(requestMetrics);

        // eslint-disable-next-line no-restricted-syntax
        for (const metricResult of metricsResults) {
          if (metricResult.value.error !== undefined && metricResult.value.error === true) {
            // eslint-disable-next-line no-continue
            continue;
          }

          const requestConfigData = JSON.parse(metricResult.value.config.data);
          const metricKey = requestConfigData.metric.key;

          const metricData = metricResult.status === 'fulfilled'
            ? {
              data: metricResult.value.data.result,
              status: true,
            }
            : {
              data: [],
              status: false,
            };
          this.$set(metricsData, metricKey, metricData);
        }
      } catch (err) {
        console.log(err);
      }

      if (isNeedUpdateFilters) {
        this.changeFilters(false);
      }

      this.loading = false;

      const isRequestErrors = this.reportMetrics.reduce(
        (accum, cur) => accum || cur.error,
        0,
      );

      if (isRequestErrors) {
        await this.setSnack({
          snack: true,
          color: 'red',
          text: `Couldn't get data from: ${this.reportMetrics.filter((el) => el.error)
            .map((el) => el.name).join(', ')}`,
        });
      }

      return metricsData;
    },

    async getAnalyticsBulk(collectedMetrics, isNeedUpdateFilters = true) {
      const metricsData = [];
      this.bulkLoading = true;

      // eslint-disable-next-line max-len
      const requestMetrics = this.prepareRequestMetrics(collectedMetrics);

      try {
        const metricsResults = await this.analyticsResolveBulk(requestMetrics);

        Object.entries(metricsResults.data.result).forEach(([metricKey, value]) => {
          const metricData = {
            data: value.data,
            status: value.status,
          };

          this.$set(metricsData, metricKey, metricData);

          if (value.status) {
            const itemIndex = this.reportMetrics
              .findIndex((el) => el.metricKey === metricKey);

            this.reportMetrics[itemIndex].error = 0;
          }
        });
      } catch (err) {
        console.log(err);
      }

      if (isNeedUpdateFilters) {
        this.changeFilters(false);
      }

      this.bulkLoading = false;

      const isRequestErrors = this.reportMetrics.reduce(
        (accum, cur) => accum || cur.error,
        0,
      );

      if (isRequestErrors) {
        await this.setSnack({
          snack: true,
          color: 'red',
          text: `Couldn't get data from: ${this.reportMetrics.filter((el) => el.error)
            .map((el) => el.name).join(', ')}`,
        });
      }

      return metricsData;
    },

    async analyticsResolve(requestMetrics) {
      const requestPromises = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const requestMetric of requestMetrics) {
        const currentPromise = this.fulfillWithCounter(
          this.getTimeSpreadAggregatedRequest(requestMetric),
          requestMetric,
        );

        requestPromises.push(currentPromise);
      }

      return Promise.allSettled(requestPromises);
    },

    async analyticsResolveBulk(requestMetrics) {
      return this.getTimeSpreadAggregatedRequestBulk(requestMetrics);
    },

    async getTimeSpreadAggregatedRequest(requestMetric) {
      return this.axios
        .post('api/admin/analytics/getAggregatedData',
          requestMetric);
    },

    async getTimeSpreadAggregatedRequestBulk(requestMetrics) {
      return this.axios
        .post('api/admin/analytics/getAggregatedDataBulk',
          {
            request_type: this.requestType,
            metrics: requestMetrics,
          });
    },

    async setPeriodStep(stepDirection) {
      switch (this.periodSelectedComputed) {
        case 'this-month':
        case 'month_1':
          if (stepDirection === 'prev') {
            this.setPreviousMonthBounds();
          } else {
            this.setNextMonthBounds();
          }
          break;
        case 'this-year':
          if (stepDirection === 'prev') {
            this.setPreviousYearBounds();
          } else {
            this.setNextYearBounds();
          }
          break;
        case 'today':
        default:
          if (stepDirection === 'prev') {
            this.setPreviousDayBounds();
          } else {
            this.setNextDayBounds();
          }
      }

      this.changeFilters();
    },

    async initBoundsTime() {
      this.isDisabledNextButton = true;

      this.endDate = new Date();
      this.endDate.setMinutes(0, 0, 0);

      switch (this.periodSelectedComputed) {
        case 'hour_12':
          this.beginDate = new Date(
            this.endDate.getTime() - 1000 * 60 * 60 * 12,
          );
          break;
        case 'hour_24':
          this.endDate.setUTCHours(0, 0, 0, 0);
          this.beginDate = new Date(
            this.endDate.getTime() - 1000 * 60 * 60 * 24,
          );
          this.endDate.setUTCHours(0, 0, 0, -1);

          break;
        case 'day_7':
          this.endDate.setUTCHours(0, 0, 0, 0);
          this.beginDate = new Date(
            this.endDate.getTime() - 1000 * 60 * 60 * 24 * 7,
          );
          this.endDate.setUTCHours(0, 0, 0, -1);

          break;
        case 'day_30':
          this.endDate.setUTCHours(0, 0, 0, 0);
          this.beginDate = new Date(
            this.endDate.getTime() - 1000 * 60 * 60 * 24 * 30,
          );
          this.endDate.setUTCHours(0, 0, 0, -1);

          break;
        case 'this-month':
          this.beginDate = new Date(
            Date.UTC(
              this.endDate.getUTCFullYear(),
              this.endDate.getUTCMonth(),
              1, 0, 0, 0, 0,
            ),
          );
          break;
        case 'month_1':
          this.setPreviousMonthBounds();
          break;
        case 'this-year':
          this.beginDate = new Date(
            Date.UTC(
              this.endDate.getUTCFullYear(),
              0, 1, 0, 0, 0, 0,
            ),
          );
          break;
        case 'month_6':
          this.beginDate = new Date(
            Date.UTC(
              this.endDate.getUTCFullYear(),
              this.endDate.getUTCMonth() - 6,
              this.endDate.getUTCDate(),
              this.endDate.getUTCHours(),
              this.endDate.getUTCMinutes(),
              this.endDate.getUTCSeconds(),
              this.endDate.getUTCMilliseconds(),
            ),
          );
          break;
        case 'month_12':
          this.beginDate = new Date(
            Date.UTC(
              this.endDate.getUTCFullYear(),
              this.endDate.getUTCMonth() - 12,
              this.endDate.getUTCDate(),
              this.endDate.getUTCHours(),
              this.endDate.getUTCMinutes(),
              this.endDate.getUTCSeconds(),
              this.endDate.getUTCMilliseconds(),
            ),
          );
          break;
        case 'custom':
          this.openDateRangeDialog();
          return false;
        case 'realtime':
        case 'all-time':
        case 'today':
        default:
          this.beginDate = new Date(
            Date.UTC(
              this.endDate.getUTCFullYear(),
              this.endDate.getUTCMonth(),
              this.endDate.getUTCDate(),
              0, 0, 0, 0,
            ),
          );
      }

      return true;
    },

    setPreviousDayBounds() {
      this.isDisabledNextButton = false;

      this.endDate.setUTCHours(0);
      this.endDate.setUTCMinutes(0);
      this.endDate.setUTCSeconds(0);
      this.endDate.setUTCMilliseconds(-1);

      this.beginDate = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          this.endDate.getUTCMonth(),
          this.endDate.getUTCDate(),
          0, 0, 0, 0,
        ),
      );
    },

    setNextDayBounds() {
      const endTime = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          this.endDate.getUTCMonth(),
          this.endDate.getUTCDate() + 2,
          0, 0, 0, -1,
        ),
      );
      const nowTime = Date.now();
      if (endTime.getTime() <= nowTime) {
        this.endDate = new Date(endTime.getTime());
      } else {
        this.isDisabledNextButton = true;
        this.endDate = new Date(nowTime);
      }

      this.beginDate = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          this.endDate.getUTCMonth(),
          this.endDate.getUTCDate(),
          0, 0, 0, 0,
        ),
      );
    },

    setPreviousMonthBounds() {
      this.isDisabledNextButton = false;

      this.endDate.setUTCDate(1);
      this.endDate.setUTCHours(0);
      this.endDate.setUTCMinutes(0);
      this.endDate.setUTCSeconds(0);
      this.endDate.setUTCMilliseconds(-1);

      this.beginDate = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          this.endDate.getUTCMonth(),
          1, 0, 0, 0, 0,
        ),
      );
    },

    setNextMonthBounds() {
      const endTime = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          this.endDate.getUTCMonth() + 2,
          1, 0, 0, 0, -1,
        ),
      );
      const nowTime = Date.now();
      if (endTime.getTime() <= nowTime) {
        this.endDate = new Date(endTime.getTime());
      } else {
        this.isDisabledNextButton = true;
        this.endDate = new Date(nowTime);
      }

      this.beginDate = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          this.endDate.getUTCMonth(),
          1, 0, 0, 0, 0,
        ),
      );
    },

    setPreviousYearBounds() {
      this.isDisabledNextButton = false;

      this.endDate.setUTCMonth(0);
      this.endDate.setUTCDate(1);
      this.endDate.setUTCHours(0);
      this.endDate.setUTCMinutes(0);
      this.endDate.setUTCSeconds(0);
      this.endDate.setUTCMilliseconds(-1);

      this.beginDate = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          0, 1, 0, 0, 0, 0,
        ),
      );
    },

    setNextYearBounds() {
      const endTime = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear() + 2,
          0,
          0, 0, 0, 0, -1,
        ),
      );
      const nowTime = Date.now();
      if (endTime.getTime() <= nowTime) {
        this.endDate = new Date(endTime.getTime());
      } else {
        this.isDisabledNextButton = true;
        this.endDate = new Date(nowTime);
      }

      this.beginDate = new Date(
        Date.UTC(
          this.endDate.getUTCFullYear(),
          0, 1, 0, 0, 0, 0,
        ),
      );
    },

    async selectPeriod() {
      if (await this.initBoundsTime()) {
        this.changeFilters();
      }
    },

    openDateRangeDialog() {
      this.customDateRange = [];
      this.isDatepickerDialogOpen = true;
    },

    closeDateRangeDialog() {
      this.isDatepickerDialogOpen = false;
    },

    cancelDateRangeDialog() {
      this.closeDateRangeDialog();
    },

    async saveDataRange() {
      const firstDate = new Date(Date.parse(`${this.customDateRange[0]} UTC`));
      const secondDate = new Date(Date.parse(`${this.customDateRange[1]} UTC`));

      [this.beginDate, this.endDate] = [firstDate, secondDate]
        .sort((a, b) => a.getTime() - b.getTime());

      this.endDate.setUTCHours(24, 0, 0, -1);

      this.changeFilters();
      this.closeDateRangeDialog();
    },

    convertDateToUTC(date) {
      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
      );
    },

    async changeCustomer() {
      this.changeFilters();
      await this.fetchDashboardStructure();
    },

    async changeDashboard() {
      this.changeFilters();
      await this.fetchDashboardStructure();
    },

    saveAsPdf() {
      const options = {
        backgroundColor: null,
        allowTaint: true,
        useCORS: true,
      };

      // eslint-disable-next-line new-cap
      const doc = new jsPDF('l', 'px', 'a4');
      const width = doc.internal.pageSize.getWidth();
      const height = doc.internal.pageSize.getHeight();

      html2canvas(this.$refs.topdf.$el, options).then((canvas) => {
        const imgData = canvas.toDataURL('image/png', 1.0)
          .replace('image/png', 'image/octet-stream');

        doc.addImage(imgData, 'PNG', 0, 0, width, height);
        doc.save(`${this.currentCompositeCustomer.name}.pdf`);
      });
    },

    exportData() {
      if (this.isExportRangeIncompleteUtcDay) {
        this.setSnack({
          snack: true,
          color: 'red',
          text: 'Data for export for this UTC day is not ready yet. '
            + `Please try again after ${this.nextUtcDayReadyAt}.`,
        });
        return;
      }

      this.$requestHelpers
        .post(
          'api/admin/export',
          {
            composite_customer_id: this.currentCompositeCustomer.id,
            timestamp_begin: this.beginDate.getTime(),
            timestamp_end: this.endDate.getTime(),
          },
          {
            responseType: 'blob',
          },
        )
        .then((response) => {
          const contentType = response.headers['content-type'];

          if (contentType.includes('application/json')) {
            const reader = new FileReader();
            reader.onload = () => {
              const json = JSON.parse(reader.result);

              this.setSnack({
                snack: true,
                color: json.status === 'error' ? 'red' : 'orange',
                text: json.message,
              });
            };
            reader.readAsText(response.data);
          } else {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
        }).catch((error) => {
          const reader = new FileReader();
          reader.onload = () => {
            const json = JSON.parse(reader.result);

            this.setSnack({
              snack: true,
              color: 'red',
              text: json.message,
            });
          };
          reader.readAsText(error.response.data);
        });
    },

    exportSearchData() {
      this.$requestHelpers
        .post(
          'api/admin/exportSearchData',
          {
            composite_customer_id: this.currentCompositeCustomer.id,
            timestamp_begin: this.beginDate.getTime(),
            timestamp_end: this.endDate.getTime(),
          },
          {
            responseType: 'blob',
          },
        )
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const headerval = response.headers['content-disposition'];
          const filename = headerval.match(/filename=(.*)/);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename[1]);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  async deactivated() {
    if (this.$websocket.initEcho) {
      await this.stopListenWs();
    }

    this.$destroy();
  },

  computed: {
    ...mapGetters({
      compositeCustomersList: 'compositeCustomers/compositeCustomersList',
      userId: 'auth/userId',
      periodSelected: 'controls/periodSelected',
      isGlobalPercent: 'controls/isGlobalPercent',
      intervalNotation: 'controls/intervalNotation',
      airportAppUrl: 'metrics/airportAppUrl',
      metricsList: 'metrics/metricsList',
      metricsData: 'metrics/metricsData',
      routeDestinationsFilter: 'metrics/routeDestinationsFilter',
      isCompositeCustomerHasAirport: 'metrics/isCompositeCustomerHasAirport',
    }),

    periodSelectedComputed: {
      get() {
        return this.periodSelected;
      },

      set(value) {
        this.setPeriodSelected(value);
      },
    },

    isGlobalPercentComputed: {
      get() {
        return this.isGlobalPercent;
      },

      set(value) {
        this.setIsGlobalPercent(value);
      },
    },

    currentCompositeCustomer: {
      get() {
        return this.$store.state.compositeCustomers.currentCompositeCustomer;
      },

      set(value) {
        this.$store.commit('compositeCustomers/SET_CURRENT_COMPOSITE_CUSTOMER', value);
      },
    },

    selectedDashboardId: {
      get() {
        return this.currentCompositeCustomer.selectedDashboardId ?? null;
      },

      set(value) {
        this.currentCompositeCustomer = {
          ...this.currentCompositeCustomer,
          selectedDashboardId: value,
        };
      },
    },

    availableDashboards() {
      return Array.isArray(this.currentCompositeCustomer.dashboards)
        ? this.currentCompositeCustomer.dashboards
        : [];
    },

    loadedMetricsPercent() {
      const total = this.reportMetrics.length;

      const loaded = this.reportMetrics.reduce((accum, cur) => {
        if (cur.status === 1) return accum + 1;
        return accum;
      },
      0);

      return total ? ((loaded * 100) / total).toFixed(0) : 0;
    },

    isEmptyCustomDateRange() {
      return this.customDateRange.length < 2;
    },

    isExportRangeIncompleteUtcDay() {
      if (!this.endDate) {
        return false;
      }

      const currentUtcDayStart = Date.UTC(
        (new Date()).getUTCFullYear(),
        (new Date()).getUTCMonth(),
        (new Date()).getUTCDate(),
        0,
        0,
        0,
        0,
      );

      return this.endDate.getTime() >= currentUtcDayStart;
    },

    nextUtcDayReadyAt() {
      const now = new Date();
      const nextUtcDayStart = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        0,
        0,
        0,
        0,
      );

      return `${new Date(nextUtcDayStart).toISOString().slice(0, 19).replace('T', ' ')} UTC`;
    },

    isScrollButtonsDisabled() {
      switch (this.periodSelectedComputed) {
        case 'reset':
          return this.wasScrollButtonsDisabled;
        case 'today':
        case 'day':
        case 'this-month':
        case 'month_1':
        case 'this-year':
          return false;
        default:
          return true;
      }
    },

    shownDate() {
      if (!this.beginDate) {
        return '';
      }
      switch (this.periodSelectedComputed) {
        case 'reset':
          return this.previouslyShownDate;
        case 'today':
        case 'day':
          return `${this.dayOfWeekNames[this.beginDate.getUTCDay()]},
           ${this.beginDate.getUTCDate()} ${this.monthFullNames[this.beginDate.getUTCMonth()]}`;
        case 'this-month':
        case 'month_1':
          return `${this.monthFullNames[this.beginDate.getUTCMonth()]} ${this.beginDate.getUTCFullYear()}`;
        case 'this-year':
          return `Year of ${this.beginDate.getUTCFullYear()}`;
        case 'month_6':
        case 'month_12':
        case 'hour_24':
        case 'day_7':
        case 'day_30':
        case 'custom':
          return `${this.monthFullNames[this.beginDate.getUTCMonth()]} ${this.beginDate.getUTCDate()}, ${this.beginDate.getUTCFullYear()} -
          ${this.monthFullNames[this.endDate.getUTCMonth()]} ${this.endDate.getUTCDate()}, ${this.endDate.getUTCFullYear()}`;
        default:
          return '';
      }
    },
  },
};
</script>

<style>
input[type="radio"] {
  vertical-align: text-bottom;
}

input[type="checkbox"] {
  vertical-align: middle;
}

label, input[type=button], input[type=submit], button {
  cursor: pointer;
}

button, input, select, textarea {
  margin: 0;
}

button {
  width: auto;
  overflow: visible;
}

.clearfix:before, .clearfix:after {
  content: "\0020";
  display: block;
  height: 0;
  visibility: hidden;
}

.clearfix:after {
  clear: both;
}

.clearfix {
  zoom: 1;
}

html {
  height: 100%;
}

body {
  width: 100%;
  min-height: 100%;
  height: 100%;
}

strong {
  font-weight: 700;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.hidden {
  display: none;
}

.invisible {
  visibility: hidden;
}

.transparent {
  opacity: 0;
}
</style>

<style scoped>
.item-clicker:hover {
  cursor: pointer;
}

</style>
